export default function DevBanner() {
  if (import.meta.env.PROD) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 text-white text-center py-1 text-sm font-bold tracking-wide">
      DEVELOPMENT ONLY: THIS IS NOT BEING SAVED
    </div>
  )
}
